import { render } from "./InstructorBlogDetails.vue?vue&type=template&id=79ff54d4"
import script from "./InstructorBlogDetails.vue?vue&type=script&lang=js"
export * from "./InstructorBlogDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__